module.exports = __webpack_public_path__ + "media/images/faces/face24-af6774112fa8d6863101f7f414cf96c0.jpg";